import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { TextButton, IconType } from '@checkmarx/cx-ui';
import LdapEditFormsContainer from './ldapEditFormsContainer';
import { LdapEditMode } from '../../services/enums/ldap';
import LdapServerGrid from './ldapServerGrid';

@inject('translationsStore', 'rootLdapStore') @observer
export default class LdapServers extends Component {

    state = {
        add: false
    };

    openAddServerForm = () => {

        this.setState({
            add: true
        });
    }

    cancelAdd = () => {

        this.props.rootLdapStore.ldapStore.resetForm();
        this.props.rootLdapStore.ldapValidator.resetForm();

        this.setState({
            add: false
        });
    }

    render() {

        let ldapServers = null;

        if (this.props.ldapServers != undefined) {
            
            ldapServers = <LdapServerGrid ldapServers={this.props.ldapServers} />;
        }

        return(
            <div className='ldap-servers-main-wrapper'>
                {ldapServers}
                <div className='add-server-button-wrapper'>
                    {
                        this.state.add ? <div className='ldap-add-form-wrapper'>
                                            <LdapEditFormsContainer mode={LdapEditMode.add} cancelAddEdit={this.cancelAdd} />
                                        </div> 
                                            : null
                    }
                    {
                        this.state.add ? null : <TextButton 
                                                    dataCy='add-ldap-server-button'
                                                    iconType={IconType.add}
                                                    text={this.props.translationsStore.translate('ADD_NEW_LDAP_SERVER')}
                                                    onClick={this.openAddServerForm} />
                    }
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/ldap/ldapServers.jsx